import { render, staticRenderFns } from "./AdGroupPage.vue?vue&type=template&id=f9fa83c8&scoped=true"
import script from "./AdGroupPage.vue?vue&type=script&lang=js"
export * from "./AdGroupPage.vue?vue&type=script&lang=js"
import style0 from "./AdGroupPage.vue?vue&type=style&index=0&id=f9fa83c8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fa83c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9fa83c8')) {
      api.createRecord('f9fa83c8', component.options)
    } else {
      api.reload('f9fa83c8', component.options)
    }
    module.hot.accept("./AdGroupPage.vue?vue&type=template&id=f9fa83c8&scoped=true", function () {
      api.rerender('f9fa83c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/groupBanner/AdGroupPage.vue"
export default component.exports